import React from 'react';
import ReactDragonBones from '@alo7/react-dragonbones-pixi';

interface AnimationPlayerProps {
  src: string;
  width?: number;
  height?: number;
  fileType?: string;
}

export class AnimationPlayer extends React.Component<
  AnimationPlayerProps,
  null
> {
  public render() {
    const id = Math.random()
      .toString(32)
      .substring(2);
    return (
      <div id={id}>
        <ReactDragonBones
          parent={id}
          renderer={'canvas'}
          options={{ transparent: false, backgroundColor: 0x999999 }}
          isPlay={true}
          url={this.props.src}
          width={this.props.width || 256}
          height={this.props.height || 144}
        />
      </div>
    );
  }
}
